module.exports = __webpack_public_path__ + "static/media/frux-logo.7ce28298.svg";